import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setBannerDismissed } from "src/store/slices/versionSlice";
import { X } from "@phosphor-icons/react";

const SoftUpdateBanner = () => {
  const dispatch = useDispatch();
  const versionAction = useSelector((state) => state.version.versionAction);
  const isBannerDismissed = useSelector((state) => state.version.isBannerDismissed);
  const softUpdateMessage = useSelector((state) => state.version.softUpdateMessage);

  if (versionAction !== "SOFT_UPDATE" || isBannerDismissed) return null;

  const message = softUpdateMessage || "A new version is available. Refresh for the best experience.";

  return (
    <div className="flex items-center justify-between px-4 py-2.5 bg-[#1B2B48] text-white text-[14px]">
      <span className="flex-1 text-center">{message}</span>
      <div className="flex items-center gap-3 ml-4 flex-shrink-0">
        <button
          onClick={() => window.location.reload()}
          className="underline font-[500] text-white text-[14px] hover:text-white/80 transition-colors"
        >
          Refresh
        </button>
        <button
          onClick={() => dispatch(setBannerDismissed())}
          className="text-white/70 hover:text-white transition-colors"
          aria-label="Dismiss"
        >
          <X size={16} weight="bold" />
        </button>
      </div>
    </div>
  );
};

export default SoftUpdateBanner;
